import React from 'react';
import { useNavigate } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faArrowRight, faChartLine, faCreditCard, faPercent, faShieldHalved, faWallet } from '@fortawesome/free-solid-svg-icons';
import './FluxopayConfigTab.css';

const benefits = [
  { icon: faPercent, title: 'Taxas reduzidas', text: 'Aproveite as condições disponíveis para clínicas parceiras e economize nos recebimentos.' },
  { icon: faCreditCard, title: 'Pix e cartão', text: 'Ofereça mais opções para seus pacientes pagarem pelos atendimentos.' },
  { icon: faWallet, title: 'Tudo integrado', text: 'Gerencie os pagamentos dentro do Fluxo Clínica, junto à rotina da sua clínica.' },
  { icon: faChartLine, title: 'Controle financeiro', text: 'Acompanhe pagamentos, taxas e valores a receber em um só painel.' },
];
const steps = [
  ['Acesse o painel', 'Conheça as taxas e condições disponíveis para sua clínica.'],
  ['Solicite a ativação', 'O Representante Legal revisa os dados empresariais e envia a solicitação.'],
  ['Acompanhe a análise', 'Consulte o andamento pelo painel. Após a aprovação, comece a utilizar o serviço.'],
];

export default function FluxopayConfigTab() {
  const navigate = useNavigate();
  return (
    <div className="fluxopay-intro">
      <header className="fluxopay-intro-heading">
        <div><span className="fluxopay-intro-eyebrow">FINANCEIRO DA SUA CLÍNICA</span><h2>Conheça o Fluxopay</h2></div>
        <span className="fluxopay-intro-tag"><FontAwesomeIcon icon={faWallet} /> Integrado ao Fluxo Clínica</span>
      </header>

      <section className="fluxopay-intro-hero" aria-labelledby="fluxopay-intro-title">
        <div className="fluxopay-intro-copy">
          <span className="fluxopay-intro-brand"><FontAwesomeIcon icon={faWallet} /> FLUXOPAY</span>
          <h3 id="fluxopay-intro-title">Uma nova forma de receber.<br /><span>Mais vantagens para sua clínica.</span></h3>
          <p>O meio de pagamento integrado ao Fluxo Clínica. Receba por Pix e cartão, aproveite taxas reduzidas para clínicas parceiras e acompanhe seus recebimentos sem sair do sistema.</p>
          <button type="button" className="fluxopay-intro-button" onClick={() => navigate('/fluxopay')}>Abrir painel Fluxopay <FontAwesomeIcon icon={faArrowRight} /></button>
          <span className="fluxopay-intro-caption">Consulte as taxas e condições da sua clínica no painel.</span>
        </div>
        <aside className="fluxopay-intro-summary" aria-label="Recursos do Fluxopay">
          <div className="fluxopay-intro-summary-top"><span>SEUS RECEBIMENTOS</span><FontAwesomeIcon icon={faWallet} /></div>
          <h4>Mais clareza em cada pagamento</h4>
          <p>Da cobrança ao acompanhamento dos valores a receber.</p>
          <div className="fluxopay-intro-methods"><span>Pix</span><span><FontAwesomeIcon icon={faCreditCard} /> Cartão</span></div>
          <div className="fluxopay-intro-summary-footer"><FontAwesomeIcon icon={faChartLine} /><div><strong>Uma visão completa</strong><span>Pagamentos, taxas e recebimentos</span></div></div>
        </aside>
      </section>

      <section className="fluxopay-intro-benefits" aria-label="Benefícios para sua clínica">
        {benefits.map(({ icon, title, text }) => <article className="fluxopay-intro-benefit" key={title}><span className="fluxopay-intro-icon"><FontAwesomeIcon icon={icon} /></span><h3>{title}</h3><p>{text}</p></article>)}
      </section>

      <section className="fluxopay-intro-start" aria-labelledby="fluxopay-start-title">
        <div className="fluxopay-intro-start-heading"><span className="fluxopay-intro-eyebrow">PRÓXIMOS PASSOS</span><h3 id="fluxopay-start-title">Começar é simples</h3><p>Prepare sua clínica para receber com o Fluxopay.</p><span className="fluxopay-intro-review"><FontAwesomeIcon icon={faShieldHalved} /> Ativação sujeita à análise</span></div>
        <ol className="fluxopay-intro-steps">{steps.map(([title, text], index) => <li key={title}><span className="fluxopay-intro-step-number">0{index + 1}</span><div><h4>{title}</h4><p>{text}</p></div></li>)}</ol>
      </section>
    </div>
  );
}